var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg67(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0002 39.7808C10.6444 39.7808 2.21924 31.3555 2.21924 20.9998C2.21924 10.6439 10.6444 2.21875 21.0002 2.21875C31.356 2.21875 39.7812 10.6439 39.7812 20.9998C39.7812 31.3555 31.356 39.7808 21.0002 39.7808ZM21.0002 4.59875C11.9562 4.59875 4.59924 11.9557 4.59924 20.9998C4.59924 30.0437 11.9562 37.4007 21.0002 37.4007C30.0442 37.4007 37.4012 30.0437 37.4012 20.9998C37.4012 11.9557 30.0442 4.59875 21.0002 4.59875Z",
    fill: "#1AC5DC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6873 26.4386L18.6187 25.551C18.4143 23.7072 19.0289 21.6926 20.7355 19.6444C22.2713 17.8356 23.1253 16.5042 23.1253 14.967C23.1253 13.2254 22.0333 12.0648 19.8815 12.0312C18.6523 12.0312 17.2873 12.4414 16.4333 13.0896L15.6143 10.9392C16.7413 10.1202 18.6873 9.57422 20.4961 9.57422C24.4217 9.57422 26.1969 11.9976 26.1969 14.5932C26.1969 16.9144 24.8991 18.5874 23.2611 20.5334C21.7589 22.3086 21.2129 23.8108 21.3151 25.5524L21.3487 26.44H18.6873V26.4386ZM17.9355 31.2182C17.9355 29.9554 18.7895 29.0678 19.9837 29.0678C21.1779 29.0678 21.9983 29.9554 21.9983 31.2182C21.9983 32.4138 21.2129 33.335 19.9501 33.335C18.7559 33.335 17.9355 32.4138 17.9355 31.2182Z",
    fill: "#1AC5DC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg67);
export default __webpack_public_path__ + "static/media/67.d3f321fcb2d80ed164974e803cce7571.svg";
export { ForwardRef as ReactComponent };